<!-- client request form -->
<p *ngIf="request">
    <app-request></app-request>
</p>

<!-- response after filling out the form -->
<p *ngIf="response">
    <app-response></app-response>
</p>